const wellcome = {
  phrase1: 'Hola',
  phrase2: 'bienvenido(a)'
}

export default wellcome;
